import save from 'save-file';

export const normalizeSalesBrands = (salesBrands = []) => {
  return salesBrands.map(item => {
    if (typeof item === 'string') {
      return {
        brandName: item,
        brandId: '',
      };
    }

    return item;
  });
};

export const getNormalisedSepaMandate = sepaMandate => {
  const defaultSepaMandate = {
    accountHolder: '',
    alternateAccountHolder: '',
    bic: '',
    city: '',
    country: 'DE',
    iban: '',
    id: '',
    street: '',
    zip: '',
  };

  return {
    ...defaultSepaMandate,
    ...sepaMandate,
  };
};

export const getNormalisedInvoice = invoice => {
  const defaultInvoice = {
    amount: 0,
    amountNet: 0,
    city: '',
    country: '',
    createdAt: '',
    dealerId: '',
    draft: false,
    easybillCustomerId: '',
    easybillDocumentId: '',
    easybillDocumentNumber: '',
    email: '',
    id: '',
    name: '',
    downloadPending: false,
    street: '',
    zip: '',
  };

  return {
    ...defaultInvoice,
    ...invoice,
  };
};

export const getNormalisedTimesBlock = timesBlock => {
  const defaultTimesBlock = {
    saturdaysChecked: false,
    sundaysChecked: false,
  };

  return {
    ...defaultTimesBlock,
    ...timesBlock,
  };
};

export const getNormalizedBranch = branch => {
  const { agentName, salesBrands } = branch;
  let leadPartnerType = 'salesTeam';

  if (agentName && agentName !== '') {
    leadPartnerType = 'centralContact';
  }

  const defaultBranch = {
    active: null,
    agentName: '',
    agentTitle: '',
    fdlConditions: '',
    id: '',
    imprint: '',
    leadEmail: '',
    secondaryLeadEmail: '',
    leadFormat: 'NONE',
    leadPartnerType,
    mobileId: '',
    name: '',
    needsNewSignature: false,
    phone: '',
    tsp: null,
    tspOther: '',
    location: {
      zip: '',
      streetName: '',
      city: '',
      houseNumber: '',
    },
    billing: {
      name: '',
      email: '',
      secondaryEmail: '',
      zip: '',
      street: '',
      city: '',
      country: '',
    },
    paymentMethod: '',
    website: '',
    salesBrands: [],
    salesLabel: null,
    sepaMandateId: null,
    saturdayOpeningTimesFrom: '',
    saturdayOpeningTimesTo: '',
    sundayOpeningTimesFrom: '',
    sundayOpeningTimesTo: '',
    weekdayOpeningTimesFrom: '',
    weekdayOpeningTimesTo: '',
    email: null,
    testDealer: false,
    // This line can be removed when all branches have moved away from transfer to SEPA
    // Since the branch payment method currently updates the redux state whenever form fields change
    // we need to set a flag in the initial state here to make sure we only remove the transfer option
    // for branches whose payment methods are saved in the DB as 'bank_transfer'.
    bankTransferOptionIsRemoved: branch.paymentMethod !== 'bank_transfer',
    allowThirdPartyProviderDistribution: true,
    selectEligible: true,
    commerceDealerCashEligible: true,
    termsAndConditionsLink: '',
  };

  /**
   * Reformat the salesBrands so they come through as
   * an array of Object({ brandId, brandName }).
   */
  branch.salesBrands = normalizeSalesBrands(salesBrands);

  return {
    ...defaultBranch,
    ...branch,
  };
};

// TODO: shouldn't this have a deleted property?
// see Network.proptypes.js

/**
 *
 * @param {import('./Network/reducer').Network} [network]
 * @returns {import('./Network/reducer').Network}
 */
export const getNormalizedNetwork = (network = {}) => {
  const defaultNetwork = {
    id: '',
    active: true,
    name: '',
    street: '',
    city: '',
    zip: '',
    country: 'DE',
    responsiblePersonFirstName: '',
    responsiblePersonLastName: '',
    responsiblePersonEmail: '',
    responsiblePersonPhone: '',
    email: '',
    phone: '',
    guaranteeType: '',
    rolloutDate: '',
    createdAt: '',
    lastUpdatedAt: '',
  };

  return {
    ...defaultNetwork,
    ...network,
  };
};

export const extractOpeningTimes = (openingTimes = []) => {
  const weekday = openingTimes[0];
  const saturday = openingTimes[5];
  const sunday = openingTimes[6];

  return {
    weekDay: {
      from: weekday ? weekday.openFrom : undefined,
      to: weekday ? weekday.openTo : undefined,
    },
    saturday: {
      from: saturday ? saturday.openFrom : undefined,
      to: saturday ? saturday.openTo : undefined,
    },
    sunday: {
      from: sunday ? sunday.openFrom : undefined,
      to: sunday ? sunday.openTo : undefined,
    },
  };
};

export const remapOpeningTimes = branch => {
  const weekDays = [...new Array(7)];
  const {
    weekdayOpeningTimesFrom,
    weekdayOpeningTimesTo,
    saturdayOpeningTimesFrom,
    saturdayOpeningTimesTo,
    sundayOpeningTimesFrom,
    sundayOpeningTimesTo,
  } = branch;

  return weekDays.map((openingTimeItem, idx) => {
    const dayOfWeek = idx + 1;
    const openingTime = { dayOfWeek };

    if (dayOfWeek < 6) {
      openingTime.openFrom = weekdayOpeningTimesFrom;
      openingTime.openTo = weekdayOpeningTimesTo;
    }
    if (dayOfWeek === 6) {
      openingTime.openFrom = saturdayOpeningTimesFrom;
      openingTime.openTo = saturdayOpeningTimesTo;
    }
    if (dayOfWeek === 7) {
      openingTime.openFrom = sundayOpeningTimesFrom;
      openingTime.openTo = sundayOpeningTimesTo;
    }
    return openingTime;
  });
};

export const remapBranchForSubmit = (branch, network, includeBilling) => {
  const { paymentMethod, leadPartnerType } = branch;
  const openingTimes = remapOpeningTimes(branch);
  const newBranch = {
    ...branch,
    network,
    openingTimes,
  };
  /**
   * This is a nicer way of using destructuring
   * so that we can exclude the props we no longer need
   * and assign the rest that we do to the 'remappedBranch'
   */
  const {
    saturdayOpeningTimesFrom,
    saturdayOpeningTimesTo,
    sundayOpeningTimesFrom,
    sundayOpeningTimesTo,
    weekdayOpeningTimesFrom,
    weekdayOpeningTimesTo,
    ...remappedBranch
  } = newBranch;

  if (!includeBilling) {
    delete remappedBranch.billing;
  }

  if (paymentMethod && paymentMethod === 'bank_transfer') {
    delete remappedBranch.sepaMandateId;
  }

  if (leadPartnerType === 'salesTeam') {
    delete remappedBranch.agentName;
  }

  return remappedBranch;
};

export const remapBranchFromResponse = (item, network) => {
  const { billing } = item;
  const { name, email, street, additional, zip, city, country } = network;

  if (!billing) {
    return {
      ...item,
      billing: {
        name,
        email,
        street,
        additional,
        zip: zip.toString(),
        city,
        country,
      },
      complete: true,
    };
  }

  return { ...item, complete: true };
};

export const getFdlObject = (value, fdlOptions = []) => {
  const matching = fdlOptions.filter(val => val.value === value);

  if (matching.length > 0) {
    return matching[0];
  }
  return null;
};

export const saveBlob = (blob, filename) => {
  /* istanbul ignore next */
  return save(blob, filename);
};
